<!-- Welcome -->
<div class="card welcome" *ngIf="item.type === 'welcome'">
  <div class="card__head">
    <div class="card__image default">
      <img
        *ngIf="whitelabelIcon"
        [src]="whitelabelIcon"
        appImgFallback
        width="40"
        height="40"
        [alt]=""
      />
    </div>
    <div class="card__title">
      <span
        ><span>{{ whitelabelName }}</span></span
      >
      <span>{{ item.addedAt | date : 'longDate' }}</span>
    </div>
  </div>
  <div class="card__content">
    <h2>{{ 'feed.welcome.title' | translate }}</h2>
    <div>
      <p *ngIf="!isProjectApp">{{ 'feed.welcome.description' | translate }}</p>
      <p *ngIf="isProjectApp">
        {{ 'feed.welcome.description.project-app' | translate }}
      </p>
    </div>
  </div>
  <div class="card__buttons">
    <ng-container *ngIf="!isProjectApp">
      <button routerLink="/search" class="button button--primary" role="link">
        {{ 'feed.welcome.addProjects' | translate }}
      </button>
      <button
        routerLink="/about-app"
        role="link"
        *ngIf="whitelabelText"
        class="button button--secondary"
      >
        {{ 'page.settings.about-app' | translate }}
      </button>
    </ng-container>
  </div>
</div>

<!-- Recommended/new project -->
<div class="card" *ngIf="item.type === 'newProject'">
  <div class="card__head">
    <div class="card__image default">
      <img
        *ngIf="whitelabelIcon"
        [src]="whitelabelIcon"
        appImgFallback
        width="40"
        height="40"
        [alt]="whitelabelName"
      />
    </div>
    <div class="card__title">
      <span
        ><span>{{ whitelabelName }}</span></span
      >
      <span>{{ item.addedAt | date : 'longDate' }}</span>
    </div>
  </div>
  <div class="card__content feed__project">
    <p class="card__new">{{ 'feed.new.project' | translate }}</p>
    <h2>{{ item.project.name }}</h2>
    <p>
      {{ 'feed.new.project.started' | translate }}
      <b> {{ item.project.customer.name }}.</b>
    </p>
    <p>{{ 'feed.new.project.update' | translate }}</p>
  </div>
  <div class="card__buttons">
    <button
      [routerLink]="['projects', item.project.slug]"
      role="link"
      class="button button--primary"
    >
      {{ 'feed.new.button.show' | translate }}
    </button>
    <button (click)="removeFromFeed(item.id)" class="button button--secondary">
      {{ 'feed.new.button.notInterested' | translate }}
    </button>
  </div>
</div>

<!-- Feedback monitor -->
<app-card
  *ngIf="item.type === 'rating'"
  [type]="CardType.RATING"
  [language]="item.project.language"
  [project]="item.project"
  [dateAdded]="item.addedAt"
  [withHeader]="true"
  [withFollowers]="false"
></app-card>

<!-- Survey -->
<div class="card" *ngIf="item.type === 'survey'">
  <div
    class="card__head"
    tabindex="0"
    role="link"
    (click)="openProject(item.project)"
  >
    <div class="card__image default">
      <img
        *ngIf="item.project.logoThumbnails"
        appImgFallback
        [src]="item.project.logoThumbnails.small"
        width="40"
        height="40"
        aria-hidden="true"
        alt=""
      />
      <img
        *ngIf="!item.project.logoThumbnails"
        appImgFallback
        [src]="item.project.customer.logoThumbnails?.small"
        width="40"
        height="40"
        aria-hidden="true"
        alt=""
      />
    </div>
    <div class="card__title">
      <span>
        <span>{{ item.project.name }}</span>
        <span aria-hidden="true">{{ item.project.participants }}</span>
      </span>
      <span
        >{{ item.addedAt | date : 'longDate' }} •
        {{ item.addedAt | date : 'shortTime' }}</span
      >
    </div>
  </div>
  <div class="card__content">
    <span>{{ 'feed.survey.title' | translate }}</span>
    <h2>{{ item.survey.title }}</h2>
    <div
      [appTranslateText]="item.survey.description"
      [language]="item.project.language"
      [html]="item.survey.description"
    ></div>
    <button role="link" (click)="openSurvey(item.project, item.survey.id)">
      <span>{{ 'feed.survey.action' | translate }}</span>
      <span
        aria-hidden="true"
        class="icon"
        [inlineSVG]="'/assets/icons/card/arrow-right.svg'"
      ></span>
    </button>
  </div>
</div>

<!-- General message -->
<div class="card" *ngIf="item.type === 'message'">
  <div class="card__head">
    <div class="card__image default">
      <img
        *ngIf="whitelabelIcon"
        [src]="whitelabelIcon"
        appImgFallback
        width="40"
        height="40"
        [alt]="whitelabelName"
      />
    </div>
    <div class="card__title">
      <span
        ><span>{{ whitelabelName }}</span></span
      >
      <span>{{ item.addedAt | date : 'longDate' }}</span>
    </div>
    <div
      (click)="share($event)"
      class="card__share ion-activatable"
      *ngIf="canShare"
      tabindex="0"
      role="button"
      [attr.aria-label]="'button.share' | translate"
    >
      <span [inlineSVG]="'/assets/icons/card/share.svg'"></span>
      <ion-ripple-effect></ion-ripple-effect>
    </div>
  </div>
  <div class="card__content">
    <h2>
      {{ item.message.title ? item.message.title : item.message.titleText }}
    </h2>
    <div
      [appTranslateText]="
        item.message.contentText
          | contentText
          | truncate : 300
          | readMore : item.message.contentText.length
      "
      [routerLink]="['/messages', item.message.id]"
      [language]="appLanguage"
      [html]="
        item.message.contentText
          | contentText
          | truncate : 300
          | readMore : item.message.contentText.length
      "
    ></div>
  </div>
</div>

<!-- Update -->
<div
  #updateReference
  class="card card--update"
  *ngIf="item.type === 'update' && item.projectUpdate.content"
>
  <div class="card__head">
    <div tabindex="0" role="link" (click)="openUpdateOrigin(item)">
      <div class="card__image default">
        <img
          *ngIf="item.project?.logoThumbnails"
          appImgFallback
          [src]="item.project?.logoThumbnails.small"
          width="40"
          height="40"
          alt=""
        />
        <img
          *ngIf="!item.project?.logoThumbnails"
          appImgFallback
          [src]="
            item.project?.customer.logoThumbnails?.small ||
            item.projectUpdate.customer?.logoThumbnails?.small
          "
          width="40"
          height="40"
          alt=""
        />
      </div>
      <div class="card__title">
        <span>
          <span>{{
            item.project?.name || item.projectUpdate.customer?.name
          }}</span>
          <span aria-hidden="true">{{ item.project?.participants }}</span>
        </span>
        <span>
          {{ item.addedAt | date : 'longDate' }} •
          {{ item.addedAt | date : 'shortTime' }}
        </span>
      </div>
      <div
        role="button"
        tabindex="0"
        [attr.aria-label]="'button.share' | translate"
        (click)="share($event)"
        class="card__share ion-activatable"
        *ngIf="canShare"
      >
        <span [inlineSVG]="'/assets/icons/card/share.svg'"></span>
        <ion-ripple-effect></ion-ripple-effect>
      </div>
    </div>
  </div>
  <div
    class="card__content"
    [attr.data-update]="item.projectUpdate.id"
    [attr.data-project]="item.project?.slug"
  >
    <h2 class="visually-hidden">
      {{ item.project?.name || item.projectUpdate?.customer?.name }}
      {{ 'projects.update' | translate }}
    </h2>
    <div class="card__content__note" *ngIf="!item.projectUpdate.starredBy">
      {{ 'feed.card.area' | translate }}
    </div>
    <div
      class="card__content__text"
      (click)="toggleReadMore(item.projectUpdate)"
      [appTranslateText]="item.projectUpdate['contentText']"
      [language]="item.project?.language"
      [update]="item.projectUpdate"
      [html]="
        item.projectUpdate['translatedContent'] ||
          item.projectUpdate['contentText']
          | truncate : getTruncateLength(item.projectUpdate)
          | readMore
            : item.projectUpdate['translatedContent']?.length ||
                item.projectUpdate['contentText'].length
      "
    ></div>
  </div>

  <div class="card__events" *ngIf="item.projectUpdate?.events?.length">
    <app-events
      [events]="item.projectUpdate.events"
      [update]="item.projectUpdate"
      (expand)="toggleReadMore(item.projectUpdate)"
      [language]="item.project.language"
    ></app-events>
  </div>
  <div>
    <button
      *ngIf="
        item.projectUpdate?.expanded &&
        (getTruncateLength(item.projectUpdate) > 300 ||
          this.eventsComponent?.canShowMore())
      "
      role="link"
      class="feed__project__button"
      (click)="openProject(item.project)"
    >
      {{ 'project.show' | translate }}
    </button>
  </div>

  <div class="card__media" *ngIf="item.projectUpdate.attachments.length">
    <app-media-slider
      [attachments]="item.projectUpdate.attachments"
      [project]="item.project"
    ></app-media-slider>
  </div>

  <div class="card__bottom">
    <app-social-buttons
      [project]="item.project"
      [update]="item.projectUpdate"
      [likedType]="likedType"
    ></app-social-buttons>
    <app-poll
      *ngIf="item.projectUpdate.poll"
      [update]="item.projectUpdate"
      [poll]="item.projectUpdate.poll"
      [project]="item.project"
    ></app-poll>
  </div>
</div>
